import { JSX } from "react";

export const Notifications = (): JSX.Element => {
    return (
        <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 13.25V11.75H1.5V6.5C1.5 5.4625 1.8125 4.54063 2.4375 3.73438C3.0625 2.92812 3.875 2.4 4.875 2.15V1.625C4.875 1.3125 4.98438 1.04688 5.20312 0.828125C5.42188 0.609375 5.6875 0.5 6 0.5C6.3125 0.5 6.57812 0.609375 6.79688 0.828125C7.01562 1.04688 7.125 1.3125 7.125 1.625V2.15C8.125 2.4 8.9375 2.92812 9.5625 3.73438C10.1875 4.54063 10.5 5.4625 10.5 6.5V11.75H12V13.25H0ZM6 15.5C5.5875 15.5 5.23438 15.3531 4.94063 15.0594C4.64687 14.7656 4.5 14.4125 4.5 14H7.5C7.5 14.4125 7.35313 14.7656 7.05938 15.0594C6.76563 15.3531 6.4125 15.5 6 15.5ZM3 11.75H9V6.5C9 5.675 8.70625 4.96875 8.11875 4.38125C7.53125 3.79375 6.825 3.5 6 3.5C5.175 3.5 4.46875 3.79375 3.88125 4.38125C3.29375 4.96875 3 5.675 3 6.5V11.75Z"
                fill="#1D2D58"
            />
        </svg>
    );
};
